export default class ClearSelectedKbItem {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.selectedKbItem.set(null);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/composition/clear_selected_kb_item.js